import { NgTemplateOutlet } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { ImageComponent } from './image/image.component';
import { MediaImageModel } from './models/media-image.model';
import { MediaVideoModel } from './models/media-video.model';
import { MediaType } from './models/media.types';
import { PlayerType, VideoComponent } from './video/video.component';

@Component({
  selector: 'mb-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ImageComponent, VideoComponent],
})
export class MediaComponent {
  @Input() autoplay = false;
  @Input() hoverplay = false;
  @Input() muted = false;
  @Input() controls = true;
  @Input() loop = false;
  @Input() hideTitles = false;
  @Input() playerType: PlayerType = PlayerType.SIMPLE;
  @Input() playsInline = false;

  @Input() media?: MediaImageModel | MediaVideoModel;

  @Output() imageError = new EventEmitter();

  public mediaType = MediaType;
}
